import localKey from './localKey'

const devApiUrl = '/';

// const proApiUrl = ''; //
// const proApiUrl = 'http://192.168.110.48:8110';  //后端本机
// const proApiUrl = 'http://192.168.110.124:8110';  //后端本机
// const proApiUrl = 'http://dev.sea.api.fxzb.vip';  //测试
// const proApiUrl = 'http://192.168.110.201:8106';  //本地
const proApiUrl = 'https://sea.api.fxzb.vip';  //线上

const nodeDevEnv = process.env.NODE_ENV == 'development' ? true : false;

export default {
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    siteName: '渠道商服务平台',
    minSiteMame: 'C',
    version: "v1.0.0",
    apiPrefix: "",
    timeout: 5000,
    cookiesExpires: 7,
    requestRetry: 4,
    requestRetryDelay: 800,
    tokenKey: 'Authorization',///'Authorization',
    userInfoKey: 'USER_INFO',
    ...localKey
}